import axios from "axios";
import {useQuery} from "@tanstack/react-query";

const fetchTxn = async (payload) => {
    const res = await axios.get(`/v1/payment/transaction/${payload}`);
    return res.data.data
}
export default function useTransaction(payload) {
    return useQuery({ queryKey: ['txn'], queryFn: () => fetchTxn(payload), enable: false, retry: false})
}